import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";
import Faq from "./Faq";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import membershipHero from "../image/membership-offers/membership-hero-v1.webp";
import membershipGuidance from "../image/membership-offers/membership-guidance-v1.webp";

const OFFER_CITIES = [
  { label: "Mumbai", value: "mumbai" }, { label: "Delhi", value: "delhi" },
  { label: "Varanasi", value: "varanasi" }, { label: "Pune", value: "pune" },
  { label: "Lucknow", value: "Lucknow" }, { label: "Kanpur", value: "Kanpur Nagar" },
  { label: "Noida", value: "noida" }, { label: "Patna", value: "Patna" },
];
const PARTNERS = ["Hipe The Gym", "FlexFlow Fitness", "Urban Kinetic", "Body Maker", "BOB'S GYM"];
const TESTIMONIALS = [
  { initials: "AM", name: "Anjali Mehra", city: "Mumbai", quote: "I found an offer that made joining my preferred gym feel possible. The enquiry process was quick and easy." },
  { initials: "RS", name: "Rohit Sharma", city: "Delhi", quote: "The right membership deal made a real difference. I could focus on getting started instead of comparing prices all day." },
  { initials: "PN", name: "Priya Nair", city: "Bengaluru", quote: "I wanted a gym close to home and a plan within my budget. MeraGym helped make the first step much simpler." },
];

export default function GymMembership() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    city: "",
    intrested_area: "",
    message: "",
  });

  const [error, setError] = useState({
    nameError: "",
    phoneError: "",
    cityError: "",
    areaError: "",
    messageError: "",
  });

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${config.apiUrl}/member-enquiry`,
        {
          name: formData.name,
          phone: formData.phone,
          city: formData.city,
          interested_area: formData.intrested_area,
          message: formData.message,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setTimeout(() => {
        const modalElement = document.getElementById("memberEnquiry");
        const modal = window.bootstrap.Modal.getInstance(modalElement);
        modal.hide();
      }, 1500);
      resetFormData();
      reserError();
    } catch (error) {
      if (error.response.status === 422) {
        setError({
          nameError: error.response.data.errors.name
            ? error.response.data.errors.name[0]
            : "",
          phoneError: error.response.data.errors.phone
            ? error.response.data.errors.phone[0]
            : "",
          cityError: error.response.data.errors.city
            ? error.response.data.errors.city[0]
            : "",
          areaError: error.response.data.errors.interested_area
            ? error.response.data.errors.interested_area[0]
            : "",
          messageError: error.response.data.errors.message
            ? error.response.data.errors.message[0]
            : "",
        });
      }
    }
  };

  const resetFormData = () => {
    setFormData({
      name: "",
      phone: "",
      city: "",
      intrested_area: "",
      message: "",
    });
  };

  const reserError = () => {
    setError({
      nameError: "",
      phoneError: "",
      cityError: "",
      areaError: "",
      messageError: "",
    });
  };

  const [city, setCity] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}/city-list`);
        setCity(response.data.city_list);
      } catch (error) {}
    };
    fetchData();
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Gym Discount Coupons & Membership Offers | MeraGym</title>
          <meta
            name="description"
            content="Get exclusive gym discount coupons and save big on gym memberships across India. Enjoy fitness at affordable rates with limited-time offers from MeraGym partner gyms."
          />
          <link rel="canonical" href="https://meragym.com/gym-membership-discounts-coupon" />
          <meta property="og:title" content="Gym Discount Coupons & Membership Offers | MeraGym" />
          <meta property="og:description" content="Exclusive gym coupons and membership discounts from partner gyms across India. Save on fitness today." />
          <meta property="og:url" content="https://meragym.com/gym-membership-discounts-coupon" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Gym Discount Coupons & Membership Offers | MeraGym" />
          <meta name="twitter:description" content="Exclusive gym coupons and membership discounts from partner gyms across India." />
        </Helmet>
      </HelmetProvider>
      <ToastContainer />
      <section className="mco-hero" style={{ backgroundImage: `url(${membershipHero})` }}>
        <div className="mco-hero-shade"></div>
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="mco-hero-copy">
                <span className="mco-kicker"><i className="bi bi-ticket-perforated-fill"></i> Membership offers, made simple</span>
                <h1>Find gym membership offers <span>near you.</span></h1>
                <p>Tell us where you want to train. We’ll help you discover partner-gym offers that fit your routine and budget.</p>
                <div className="mco-trust-row"><span><i className="bi bi-shield-check"></i> No payment required</span><span><i className="bi bi-whatsapp"></i> Help on WhatsApp</span></div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="mco-finder-card">
                <div className="mco-finder-head"><span><i className="bi bi-geo-alt-fill"></i> Start your search</span><small>Free enquiry</small></div>
                <h2>Where would you like to train?</h2>
                <label htmlFor="offer-city">City</label>
                <select id="offer-city" name="city" value={formData.city} onChange={handleFormChange}>
                  <option value="">Choose your city</option>
                  {city.map((data, index) => <option value={data.city} key={index}>{data.city}</option>)}
                </select>
                <label htmlFor="offer-area">Neighbourhood or area</label>
                <input id="offer-area" type="text" name="intrested_area" value={formData.intrested_area} onChange={handleFormChange} placeholder="e.g. Andheri West" />
                <button type="button" className="mco-primary-btn" data-bs-toggle="modal" data-bs-target="#memberEnquiry">Show available offers <i className="bi bi-arrow-right"></i></button>
                <p className="mco-finder-note"><i className="bi bi-lock-fill"></i> Your details stay private. No spam.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mco-partners" aria-label="Partner gyms">
        <div className="container"><div className="mco-partners-inner"><span>Trusted by fitness businesses including</span><div>{PARTNERS.map((partner) => <b key={partner}>{partner}</b>)}</div></div></div>
      </section>

      <section className="mco-how" aria-labelledby="mco-how-heading">
        <div className="container"><div className="row align-items-center g-5">
          <div className="col-lg-5"><div className="mco-how-photo"><img src={membershipGuidance} alt="Fitness coach helping a new member at the gym" /><div className="mco-how-photo-note"><i className="bi bi-heart-pulse-fill"></i><span><strong>Your right fit</strong>Gym, plan, and location</span></div></div></div>
          <div className="col-lg-7"><div className="mco-section-intro"><span className="mco-section-kicker">How it works</span><h2 id="mco-how-heading">A better way to begin your fitness journey.</h2><p>No endless calls or confusing plans. Start with a few details and take the next step when you’re ready.</p></div>
            <div className="mco-step-list">
              {[{ icon: "bi-pin-map-fill", title: "Tell us your preferred area", desc: "Share the city and neighbourhood where you’d like to train." }, { icon: "bi-stars", title: "Explore partner-gym options", desc: "We’ll help surface relevant membership opportunities." }, { icon: "bi-check2-circle", title: "Choose your next step", desc: "Ask for details, visit a gym, and decide at your pace." }].map((step, index) => <div className="mco-step" key={step.title}><span className="mco-step-number">0{index + 1}</span><i className={`bi ${step.icon}`}></i><div><h3>{step.title}</h3><p>{step.desc}</p></div></div>)}
            </div>
          </div>
        </div></div>
      </section>

      <section className="mco-cities" aria-labelledby="mco-cities-heading"><div className="container">
        <div className="mco-section-intro mco-section-intro--center"><span className="mco-section-kicker">Choose a city</span><h2 id="mco-cities-heading">Offers available in your city.</h2><p>Choose your location and we’ll help you find the right membership conversation.</p></div>
        <div className="mco-city-grid">{OFFER_CITIES.map((city, index) => <button key={city.label} type="button" className="mco-city-card" onClick={() => setFormData((current) => ({ ...current, city: city.value }))} data-bs-toggle="modal" data-bs-target="#memberEnquiry"><span><i className={`bi ${["bi-buildings-fill", "bi-geo-alt-fill", "bi-bank2", "bi-tree-fill"][index % 4]}`}></i></span>{city.label}<i className="bi bi-arrow-up-right"></i></button>)}</div>
      </div></section>

      <section className="mco-savings" aria-labelledby="mco-savings-heading"><div className="container"><div className="mco-section-intro"><span className="mco-section-kicker">Smarter savings</span><h2 id="mco-savings-heading">A few good ways to make your membership go further.</h2></div>
        <div className="mco-saving-grid">{[
          ["bi-calendar-event-fill", "Time your join", "Seasonal offers and new-branch periods can be worth asking about."],
          ["bi-people-fill", "Bring your people", "Ask whether a friend, family, or group plan could work for you."],
          ["bi-briefcase-fill", "Check work benefits", "Some employers or corporate programmes may offer fitness support."],
          ["bi-chat-square-heart-fill", "Ask the right questions", "Clarify what’s included before you commit to a plan."],
          ["bi-lightning-charge-fill", "Look for fresh starts", "Opening offers can be a good moment to explore a new gym."],
        ].map(([icon, title, desc]) => <article className="mco-saving-card" key={title}><i className={`bi ${icon}`}></i><h3>{title}</h3><p>{desc}</p></article>)}</div>
      </div></section>

      <section className="mco-stories" aria-labelledby="mco-stories-heading"><div className="container"><div className="mco-section-intro mco-section-intro--center"><span className="mco-section-kicker">Member stories</span><h2 id="mco-stories-heading">A more confident first step.</h2><p>What members value when they begin looking for their next gym.</p></div>
        <div className="mco-story-grid">{TESTIMONIALS.map((story) => <article className="mco-story-card" key={story.name}><i className="bi bi-quote"></i><p>“{story.quote}”</p><div><span>{story.initials}</span><section><strong>{story.name}</strong><small>{story.city}</small></section></div></article>)}</div>
      </div></section>

      <section className="mco-final-cta"><div className="container"><div><span className="mco-section-kicker">Ready when you are</span><h2>Let’s find a gym membership that feels right.</h2><p>Start with your city. We’ll take it from there.</p></div><button type="button" className="mco-primary-btn" data-bs-toggle="modal" data-bs-target="#memberEnquiry">Find offers near me <i className="bi bi-arrow-right"></i></button></div></section>

      {/**Membership Enquiry*/}
      <div
        className="modal fade"
        id="memberEnquiry"
        tabIndex="-1"
        aria-labelledby="memberEnquiry"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content member-modal">
            <div className="header">
              <h6 className="product-title">
                Fill this form to get gym discount coupons
              </h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="name">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleFormChange}
                    />
                    {error.nameError ? (
                      <small className="text-danger"> {error.nameError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="phone">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={handleFormChange}
                    />
                    {error.phoneError ? (
                      <small className="text-danger">
                        {" "}
                        {error.phoneError}{" "}
                      </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="city">
                      City
                    </label>
                    <select
                      className="form-select"
                      name="city"
                      id="city"
                      onChange={handleFormChange}
                    >
                      <option value="">Select City</option>
                      {city.map((data, index) => {
                        return (
                          <option value={data.city} key={index}>
                            {data.city}
                          </option>
                        );
                      })}
                    </select>
                    {error.cityError ? (
                      <small className="text-danger"> {error.cityError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <label className="form-label" htmlFor="intrested_area">
                      Area
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="intrested_area"
                      id="intrested_area"
                      value={formData.intrested_area}
                      onChange={handleFormChange}
                    />
                    {error.areaError ? (
                      <small className="text-danger"> {error.areaError} </small>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label" htmlFor="message">
                      Your Message
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      name="message"
                      id="message"
                      value={formData.message}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div className="col-12 text-end">
                    <button type="submit" className="submit">
                      Submit Now
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Membership enquiry */}
      <Faq page="gym_membership" />
    </>
  );
}
